import IDirectionData from "../direction/directionData";
import { IGradeCalculatedData } from "../grade/GradeCalculatedData";

export interface IPropertySpecification {
    isMeasured: boolean;
    isCalculated: boolean;
    instrumentId: string;
    propertyId: string;
    propertyName: string;
    propertyCustomId: number;
    target: string;
    sigma: string;
    gain: number;
    offset: number;
    minValue: string;
    maxValue: string;
    alarmLow1: string;
    alarmHigh1: string;
    alarmLow2: string;
    alarmHigh2: string;
    rejectLow: string;
    rejectHigh: string;
    sourceMappings: IGradeCalculatedData[];
    direction?: IDirectionData[];
    order?: number;
    sigmaPercent?:boolean;
}

export class PropertySpecification implements IPropertySpecification {
    isMeasured: boolean;
    isCalculated: boolean;
    instrumentId: string;
    propertyId: string;
    propertyName: string;
    propertyCustomId: number;
    target: string;
    sigma: string;
    gain: number;
    offset: number;
    minValue: string;
    maxValue: string;
    alarmLow1: string;
    alarmHigh1: string;
    alarmLow2: string;
    alarmHigh2: string;
    rejectLow: string;
    rejectHigh: string;
    sourceMappings: IGradeCalculatedData[];
    direction?: IDirectionData[];
    order?: number;
    sigmaPercent?: boolean;

    constructor(isMeasured: boolean, isCalculated: boolean, instrumentId: string, propertyId: string, propertyName: string, propertyCustomId: number, target: string, sigma: string, gain: number, offset: number, minValue: string,
        maxValue: string, alarmLow1: string, alarmHigh1:string, alarmLow2: string, alarmHigh2: string, rejectLow: string,
        rejectHigh: string, sourceMappings: IGradeCalculatedData[], direction?: IDirectionData[], order?: number, sigmaPercent?: boolean) {
            this.isMeasured = isMeasured;
            this.isCalculated = isCalculated;
            this.instrumentId = instrumentId;
            this.propertyId = propertyId;
            this.propertyName = propertyName;
            this.propertyCustomId = propertyCustomId;
            this.target = target;
            this.sigma = sigma;
            this.gain = gain;
            this.offset = offset;
            this.minValue = minValue;
            this.maxValue = maxValue;
            this.alarmLow1 = alarmLow1;
            this.alarmHigh1 = alarmHigh1;
            this.alarmLow2 = alarmLow2;
            this.alarmHigh2 = alarmHigh2;
            this.rejectLow = rejectLow;
            this.rejectHigh = rejectHigh;
            this.sourceMappings = sourceMappings;
            this.direction = direction;
            this.order = order;
            this.sigmaPercent = sigmaPercent ? sigmaPercent : false;
        }
}